import React, { FC } from 'react'
import { ComponentContentBlock } from '../../../models/components/contentBlock'
import GlobalContainer from '../globalContainer'
import { ContentBlockContainer } from './style'
import { Content } from './subcomponent'

type Props = {
  data: ComponentContentBlock
  useCase?: string
}

const ContentBlock: FC<Props> = ({ data, useCase }) => {
  if (!data) return null
  const content = {
    contentBlockTheme: data.contentBlockTheme || data.theme || 'Light',
    eyebrow: data.eyebrow || '',
    headline: data.headline || '',
    body: data.body || null,
    topPadding: data.topPadding || 'None',
    bottomPadding: data.bottomPadding || 'Large',
    orangeDivider: data.orangeDivider || false,
    finePrintWithHyperlinks: data.finePrintWithHyperlinks || null,
    textAlignment: data.textAlignment || 'left',
    cta: data.cta || [],
    cta1Style: data.cta1Style === 'Link' ? 'text-link' : data.cta1Style?.toLowerCase() || 'primary',
    cta2Style:
      data.cta2Style === 'Link' ? 'text-link' : data.cta2Style?.toLowerCase() || 'text-link',
    contentBlockUseCase: data.useCase || '',
    anchorLink: data.anchorLink,
  }

  const contentClassName = useCase === 'Resource' ? 'Grey' : content.contentBlockTheme
  return (
    <>
      {content.anchorLink?.identifier ? <span id={content.anchorLink?.identifier}></span> : null}
      <ContentBlockContainer
        data-cy="contentBlock"
        className={`ContentBlock--${contentClassName}`}
        $orangeDivider={content.orangeDivider}
        $alignment={content.textAlignment}
        $topPadding={content.topPadding}
        $bottomPadding={content.bottomPadding}
        $contentBlockTheme={content.contentBlockTheme}>
        <GlobalContainer
          className={content.contentBlockUseCase === 'Full width' ? 'ContentBlock--FullWidth' : ''}>
          <Content content={content} />
        </GlobalContainer>
      </ContentBlockContainer>
    </>
  )
}

export default ContentBlock
